// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { socialLinksStyles } from "@steiner/Overrides/Widgets/Basic/SocialLinks";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

socialLinksStyles.linkWrapper = {
    css: css`
        flex-shrink: 0;
    `,
};

socialLinksStyles.sectionTitle = {
    variant: "h4",
    as: "p",
    color: "common.ui1",
};

socialLinksStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        max-width: 317px;
    `,
};

socialLinksStyles.link = {
    css: css`
        & > ${IconWrapper} {
            opacity: 1;
        }

        &:not([disabled]):hover > ${IconWrapper} {
            color: ${color("common.ui12")};
        }
    `,
};
